import script from "./NextDocs.vue?vue&type=script&setup=true&lang=js"
export * from "./NextDocs.vue?vue&type=script&setup=true&lang=js"

import "./NextDocs.vue?vue&type=style&index=0&id=2531496a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2531496a"]])

export default __exports__